import { ModuleWithProviders, NgModule } from '@angular/core';

import { Setting } from './services/setting';
import { FormSessionService } from './services/form-session.service';
import { FormComponent } from './components/form/form.component';
import { PageComponent } from './components/page/page.component';
import { PanelComponent } from './components/panel/panel.component';
import { configurationSetter } from './helpers/configuration-setter';
import { SchemaFactoryService } from './services/schema-factory.service';
import { QuestionComponent } from './components/question/question.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentHostDirective } from './directives/container.directive';
import { TemplateFactoryComponent } from './components/template-factory/template-factory.component';
import { ShowHideDirective } from './directives/show-hide.directive';
import { SingleDropdownModule } from '@appkit4/angular-components/single-dropdown';
import { SharedModule } from '../../shared/shared.module';
import { FormViewerComponent } from './components/form-viewer/form-viewer.component';
import { PercentComponent } from './components/percent/percent.component';
import { YesNoComponent } from './components/yes-no/yes-no.component';
import { TextfieldQuestionComponent } from './components/textfield-question/textfield-question.component';

@NgModule({
  declarations: [
    ComponentHostDirective,
    FormViewerComponent,
    FormComponent,
    PageComponent,
    PanelComponent,
    QuestionComponent,
    YesNoComponent,
    PercentComponent,
    TextfieldQuestionComponent,
    TemplateFactoryComponent,
    ShowHideDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SingleDropdownModule,
    SharedModule,
  ],
  exports: [FormViewerComponent],
})
export class FormGeneratorEngineModule {
  static forRoot(
    setting: Setting
  ): ModuleWithProviders<FormGeneratorEngineModule> {
    return {
      ngModule: FormGeneratorEngineModule,
      providers: [
        FormSessionService,
        {
          provide: Setting,
          useValue: configurationSetter(setting),
        },
        {
          provide: SchemaFactoryService,
          useClass: setting.schemaFactory,
        },
      ],
    };
  }
}
